import { useAuth } from '@sportybot-web/auth/useAuth';
import { useQueryClient } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';

import { useDataDog } from './hooks/useDatadog';
import { router } from './router';
import { sportySdk } from './services/sporty-gateway/client';

export function App() {
  const queryClient = useQueryClient();
  const { authClient, authState, user } = useAuth();

  useDataDog({ authenticated: authState.isAuthenticated, user });

  return <RouterProvider context={{ authClient, queryClient, sportySdk, user }} router={router} />;
}
